import React from "react";
import { Box, MainText } from "app/components/common";
import {
  getBackgroundStatusColor,
  getStatusColor,
} from "app/utils/getStatusReview";
import i18n from "@microdoing/shared/i18n";

interface Props {
  status: string;
}

const ReviewStatusChip = ({ status }: Props) => {
  const color = getStatusColor(status);
  const backgroundColor = getBackgroundStatusColor(status);

  return (
    <Box
      paddingHorizontal="xs"
      paddingVertical={2}
      alignItems="center"
      justifyContent="center"
      borderRadius={4}
      backgroundColor={backgroundColor}
      flexDirection="row"
    >
      <Box
        marginRight="xxs"
        width={6}
        height={6}
        borderRadius={3}
        backgroundColor={color}
      />
      <MainText variant="l3-medium">
        {i18n.t(`status-review-${status}`)}
      </MainText>
    </Box>
  );
};

export default ReviewStatusChip;
